import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ItemGroup from "./itemGroup";
import ItemList from "./itemList";
import { TablePagination } from "@mui/material";
import { handleDeleteRowCommon } from "../ItemPageShared/ItemUtils";
// import CartSummary from "./cartSummary";
import { useCart } from "../ItemPageShared/itemContext";
import CheckoutItems from "../ItemPageShared/checkoutitem";
import { BsCart4 } from "react-icons/bs";
import './cardview.css';

// const ItemCardView = ({
//     // cart,
//     // page,
//     // setPage,
//     // searchResults,
//     // setSearchResults,
//     rowsPerPage,
//     // setRowsPerPage,
//     itemSearchTerm,
//     totalCount,
//     handleItemSelect,
//     handleDeleteRow
// }) => {
//     const {GetItm } = useSelector((state) => state.itemPage);
//     const { cart,page, setPage,
//         setDisplayedItem } = useCart();
//         const [rowsPerPage, setRowsPerPage] = useState(10);
//     // useEffect(() => {
//     //     SlicedItem(page, rowsPerPage);
//     // }, [page, rowsPerPage, GetItm]);

//     if (itemSearchTerm) {
//         const filteredData = GetItm.filter((item) =>
//             item.item_Code?.toLowerCase().includes(itemSearchTerm.toLowerCase()) ||
//             item.item_Name?.toLowerCase().includes(itemSearchTerm.toLowerCase())
//         );
//         setDisplayedItem(filteredData);
//     } else {
//         setDisplayedItem(GetItm);
//     }
//     const handleChangePage = (event, newPage) => {
//         setPage(newPage);
//     };

//     const handleChangeRowsPerPage = (event) => {
//         setRowsPerPage(parseInt(event.target.value, 10));
//         setPage(0);
//     };
//     // const SlicedItem = (page, rowsPerPage) => {
//     //     if (GetItm && GetItm.length > 0 && !itemSearchTerm) {
//     //             setDisplayedItem.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
           
//     //     }
//     // };
    
//     return (
//         <div className="itemDiv d-flex col-10">
//             <CheckoutItems/>
            
//             {/* <ItemGroup
//                 fetchData={fetchData}
//             /> */}

//             <div className="itemDiv col-12 col-sm-9 col-xl-10 col-md-8 col-xxl-10">
//                 {/* <div className="gradient col-xl-10 col-8"></div> */}
//                 <ItemList
//                     cart={cart}
//                     page={page}
//                     rowsPerPage={rowsPerPage}
//                     handleAddCart={handleItemSelect}
//                     handleDeleteRow={handleDeleteRow}
//                     itemSearchTerm={itemSearchTerm}
//                 />
//                 <div className="Cardview-pagination">
//                 <TablePagination
//                     component="div"
//                     count={totalCount} // Total count from API response
//                     page={page}
//                     onPageChange={handleChangePage}
//                     rowsPerPage={rowsPerPage}
//                     onRowsPerPageChange={handleChangeRowsPerPage}
//                 />
//                 </div>
//             </div>
//             {/* <CartSummary
//                 cart={cart}
//                 // handleCheckout={handleCheckout}
//                 // setModalShow={setModalShow}
//                 // showItems={showItems}
//                 // setIsOtherCustomer={setIsOtherCustomer}
//                 // isOtherCustomer={isOtherCustomer}
//                 // setInputValue={setInputValue}
//                 // inputValue={inputValue}
//                 // isMobile={isMobile} 
//                 />  */}

//         </div>
//     );
// }

// export default ItemCardView;import React, { useEffect, useState } from "react";


const ItemCardView = ({
    itemSearchTerm,
    isTableView,
    handleItemSelect,
    handleDeleteRow,
    // itemByGrpCode
}) => {
    const { cart, page, setPage,displayedItem ,searchResults} = useCart();
    const [rowsPerPage, setRowsPerPage] = useState(10);
    useEffect(() => {
        setPage(0);
      }, [displayedItem, setPage]);

    // const filteredData =!searchResults ?displayedItem : searchResults;
    const filteredData =
    searchResults?.length > 0 ? searchResults : displayedItem;
 
    // const paginatedData =filteredData&& filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
    // Determine the data source: filtered by itemByGrpCode or the full displayedItem
// const baseData = itemByGrpCode ? displayedItem.filter(item => 
//     item.item_Code?.toLowerCase().includes(itemSearchTerm.toLowerCase()) ||
//     item.item_Name?.toLowerCase().includes(itemSearchTerm.toLowerCase())
// ) : displayedItem || [];

// Pagination
const paginatedData = filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    return (
        <div className="itemDiv d-flex col-10">
            <CheckoutItems />
            <div className="itemDiv col-12 col-sm-9 col-xl-10 col-md-8 col-xxl-10">
                <ItemList
                    cart={cart}
                    paginatedData={paginatedData}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    handleAddCart={handleItemSelect}
                    handleDeleteRow={handleDeleteRow}
                    itemSearchTerm={itemSearchTerm}
                />
                <div className="Cardview-pagination">
                    <TablePagination
                        component="div"
                        count={filteredData.length} // total items after filtering
                        page={page}
                        onPageChange={handleChangePage}
                        rowsPerPage={rowsPerPage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        rowsPerPageOptions={[5, 10, 25, 50]}
                    />
                </div>
            </div>
        </div>
    );
};

export default ItemCardView;
